<template>
  <v-container
    id="lista-produtos-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <!-- FORMULARIO DE USUARIO NAO IDENTIFICADO ------------------------------------------------->
        <usuario-nao-identificado-form
          v-if="!usuarioIdentificado"
          :titulo="$t('cart')"
        />
        <base-material-card
          v-else
          :color="corPrimaria"
          :app-online="appOnline"
          class="py-3 px-5"
        >
          <template v-slot:heading>
            <div
              class="text-h3 font-bold-light"
            >
              <v-icon
                id="iconCart"
                class="text-h2"
              >
                mdi-cart-arrow-down
              </v-icon>
              Carrinho
            </div>
          </template>
        </base-material-card>
        <v-divider class="mb-5" />
        <v-row>
          <v-col
            cols="12"
          >
            <div
              id="divFinaliza"
              class="col-12"
            >
              <v-row>
                <v-col
                  cols="9"
                >
                  <h3>Valor do Pedido: {{ soma }}</h3>
                </v-col>
                <v-col
                  cols="3"
                >
                  <v-btn
                    id="btnFinaliza_cart"
                    :color="corPrimaria"
                    dark
                    to="/finaliza-compra"
                    class="col-6 col-sm-7"
                    @click="finalizaCompra()"
                  >
                    <router-link
                      id="finaliza-compra_cart"
                      to="/finaliza-compra"
                    >
                      <v-icon color="#ffffff">
                        mdi-cart-arrow-right
                      </v-icon>
                    </router-link>
                    <h5>Finalizar Pedido</h5>
                  </v-btn>
                </v-col>
              </v-row>
              <br><hr><hr><br>
              <div
                v-if="listaprodutos"
                id="cartIten_cart"
                class="col-12"
              >
                <ul
                  id="ul_cart"
                >
                  <li
                    v-for="lista in listaprodutos"
                    id="li_cart"
                    :key="lista.id"
                    class="col-5 lg-6 mb-4 my-2"
                  >
                    <div
                      v-if="!lista.unidade"
                    >
                      <h4>
                        <b>{{ lista.nome }}</b><br>
                      </h4>
                    </div>
                    <div
                      v-else
                    >
                      <div
                        v-if="lista.preco === 0"
                      >
                        <p id="alertaProduto">
                          Produto alterado o preço para R$ 0,00. No momento não estamos disponibilizando a venda desde produto.
                          Favor remover o item do carrinho clicando no ícone abaixo.
                        </p>
                        <v-icon
                          id="iconDelete_cart"
                          class="text-h2"
                          :color="corError"
                          @click="removeProduto(lista)"
                        >
                          mdi-delete
                        </v-icon>
                        <h5><b>{{ lista.nome }}</b></h5>
                        <hr>
                        Unidade: {{ lista.unidade }} <br>
                        {{ lista.precoExibicao }} <br>
                        Peças: {{ lista.pecas }} <br>
                        Caixas: {{ lista.caixa }} <br>
                      </div>
                      <div
                        v-else
                      >
                        <div
                          v-if="lista.imagem"
                          id="imagemProduto_cart"
                        >
                          <v-img
                            id="imagem_cart"
                            :src="lista.imagem"
                            contain
                          />
                        </div>
                        <h5><b>{{ lista.nome }}</b></h5>
                        <div id="linhaHorizontal_cart" />
                        {{ lista.precoExibicao }}/{{ lista.unidade }} <br>
                        <div v-if="exibirCaixa">
                          <div v-if="lista.quantidadeExibicao">
                            Quantidade: {{ lista.quantidadeExibicao }}
                          </div>
                          <div v-if="lista.pecas">
                            Peças: {{ lista.pecas }}
                          </div>
                          Caixa:
                        </div>
                        <div v-if="exibirPecas">
                          <div v-if="lista.quantidadeExibicao">
                            Quantidade: {{ lista.quantidadeExibicao }}
                          </div>
                          <div v-if="lista.caixa">
                            Caixas: {{ lista.caixa }}
                          </div>
                          Peças:
                        </div>
                        <div v-if="exibirQuantidade">
                          <div v-if="lista.pecas">
                            Peças: {{ lista.pecas }}
                          </div>
                          <div v-if="lista.caixa">
                            Caixas: {{ lista.caixa }}
                          </div>
                          Quantidade:
                        </div>
                        <div>
                          <div class="my-2">
                            <v-btn
                              id="btnAdd_cart"
                              small
                              :color="corError"
                              dark
                              @click="removeItem(lista)"
                            >
                              <v-icon color="#ffffff">
                                mdi-minus
                              </v-icon>
                            </v-btn>
                            <input
                              v-if="exibirCaixa"
                              id="input_cart"
                              v-model="lista.caixa"
                              v-mask="maskItem"
                              pattern="^[0-9]"
                              type="number"
                              class="text-center"
                              @keyup="lista.caixa <= 0 ? removeItem(lista) : atualizaListaCompraKeyup(lista)"
                            >
                            <input
                              v-if="exibirPecas"
                              id="input_cart"
                              v-model="lista.pecas"
                              v-mask="maskItem"
                              pattern="^[0-9]"
                              type="number"
                              class="text-center"
                              @keyup="lista.pecas <= 0 ? removeItem(lista) : atualizaListaCompraKeyup(lista)"
                            >
                            <input
                              v-if="exibirQuantidade"
                              id="input_cart"
                              v-model="lista.quantidade"
                              v-mask="maskItem"
                              pattern="^[0-9]"
                              type="number"
                              class="text-center"
                              @keyup="lista.quantidade <= 0 ? removeItem(lista) : atualizaListaCompraKeyup(lista)"
                            >
                            <v-btn
                              id="btnAdd_cart"
                              small
                              :color="corSecondaria"
                              dark
                              @click="addItem(lista)"
                            >
                              <v-icon color="#ffffff">
                                mdi-plus
                              </v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div
                v-else
              >
                <h3>Não há itens no carrinho.</h3>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
    <v-dialog
      v-model="dialog.visible"
      max-width="411"
      persistent
    >
      <v-card>
        <v-card-title>
          <v-spacer />
          <v-icon
            aria-label="Close"
            @click="dialog.visible = false"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="text-center">
          {{ dialog.message }}
        </v-card-text>
        <v-card-text class="pb-3 pt-6 text-center">
          <v-btn
            class="mr-3"
            :color="corError"
            text
            @click="resetProduto(dialog.produto), dialog.visible = false"
          >
            Não
          </v-btn>

          <v-btn
            :color="corSecondaria"
            text
            @click="confirmRemoveProduto(dialog.produto) ,dialog.visible = false"
          >
            Sim
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import Carrinho from '../../../services/carrinhoservice'
  import utils from '../../../services/utils'

  export default {
    name: 'PageCarrinhoCompras',
    components: {
      DashboardCoreSnackbar: () => import('../components/core/Snackbar'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      listaprodutos: [],
      soma: 0,
      loading_produtos: false,
      usuarioIdentificado: true,
      cart: 0,
      valid: true,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      corError: localStorage.corError,
      bloqueado: localStorage.bloqueado,
      obsBloqueado: localStorage.obsBloqueado,
      inativo: 0,
      exibirCaixa: false,
      exibirPecas: false,
      exibirQuantidade: false,
      styleObjectError: {
        color: localStorage.corError,
      },
      maskItem: '#########',
      styleObjectPromocao: {
        color: '#FFFFFF',
      },
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      dialog: {
        visible: false,
        message: '',
      },
    }),

    mounted () {
      if (localStorage.chaveativacao && localStorage.chaveativacao !== 'undefined') {
        this.chaveativacao = localStorage.chaveativacao
        if (localStorage.getItem('usuarioIdentificado') && localStorage.getItem('usuarioIdentificado') === 'true') {
          this.usuarioIdentificado = true
          localStorage.removeItem('produtoId')
          localStorage.removeItem('linhaSelect')
          localStorage.removeItem('classificacaoSelect')
          this.valorTotalCompra()
          this.carregaForm()
        } else {
          this.usuarioIdentificado = false
          localStorage.removeItem('username')
          localStorage.removeItem('email')
          localStorage.removeItem('nome')
          localStorage.removeItem('produtoId')
          localStorage.removeItem('linhaSelect')
          localStorage.removeItem('classificacaoSelect')
          this.$router.push('/login')
        }
      } else {
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('produtoId')
        this.$router.push('/login')
      }
    },

    methods: {
      carregaForm () {
        this.loading_produtos = true

        this.carregaProdutos()
        this.valorTotalCompra()
      },

      async carregaProdutos () {
        await Carrinho.show(localStorage.username, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.listaprodutos = resposta.data.itensCarrinho

            this.cart = this.listaprodutos.length

            this.bloqueado = resposta.data.bloqueado
            this.inativo = resposta.data.inativo

            localStorage.bloqueado = this.bloqueado
            localStorage.inativo = this.inativo

            this.exibirCaixa = resposta.data.exibirCaixa
            this.exibirPecas = resposta.data.exibirPecas
            this.exibirQuantidade = resposta.data.exibirQuantidade

            this.valorTotalCompra()
            this.montaImagem()
            this.editListaProdutos()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      montaImagem () {
        for (var i in this.listaprodutos) {
          var imagem = this.listaprodutos[i].imagem
          if (imagem) {
            var base64blob = imagem

            var image = document.createElement('img')

            image.src = base64blob

            this.listaprodutos[i].imagem = image.src
          }
        }
      },

      editListaProdutos () {
        const carrinholista = this.listaprodutos.map((value) => {
          var listacompra = ({
            id: value.id,
            idProduto: value.idProduto,
            carrinhoId: value.carrinhoId,
            nome: value.nome,
            unidade: value.unidade,
            preco: value.preco,
            precoExibicao: value.precoExibicao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            quantidade: value.quantidade/* .toFixed(2).toString().replace('.', ',') */,
            quantidadeExibicao: value.quantidade.toFixed(2).toString().replace('.', ','),
            estoque: value.estoque,
            pecasPorCaixa: value.pecasPorCaixa,
            pecas: value.pecas,
            caixa: value.caixa,
            referenciaUnidade: value.referenciaUnidade,
            peso: value.peso.toFixed(2).toString().replace('.', ','),
            subtotal: value.subtotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            datafim: value.fimPromocao,
            imagem: value.imagem,
          })

          return listacompra
        })

        this.listaprodutos = carrinholista
      },

      addItem (produto) {
        if (this.exibirCaixa) {
          produto.caixa = produto.caixa ? parseFloat(produto.caixa) : 1

          produto.caixa = produto.caixa += 1
          produto.pecas = produto.caixa * produto.pecasPorCaixa
          produto.quantidade = ((produto.referenciaUnidade * produto.pecasPorCaixa) * produto.caixa).toFixed(2)

          produto.quantidadeExibicao = produto.quantidade.toString().replace('.', ',')

          this.atualizarListaCompra(produto)
        } else if (this.exibirPecas) {
          produto.pecas = parseFloat(produto.pecas)

          produto.pecas += 1

          produto.caixa = produto.caixa ? Math.ceil(produto.pecas / produto.pecasPorCaixa) : 0
          produto.quantidade = (produto.pecas * produto.referenciaUnidade).toFixed(2)

          produto.quantidadeExibicao = produto.quantidade.toString().replace('.', ',')

          this.atualizarListaCompra(produto)
        } else if (this.exibirQuantidade) {
          produto.quantidade = parseFloat(produto.quantidade)

          produto.quantidade += 1

          produto.quantidadeExibicao = produto.quantidade.toString().replace('.', ',')

          produto.pecas = Math.ceil(produto.quantidade / produto.referenciaUnidade)
          produto.caixa = produto.caixa ? Math.ceil((produto.quantidade / produto.referenciaUnidade) / produto.pecasPorCaixa) : 0

          this.atualizarListaCompra(produto)
        }
      },

      removeItem (produto) {
        if (this.exibirCaixa) {
          produto.caixa -= 1

          produto.pecas = produto.caixa * produto.pecasPorCaixa
          produto.quantidade = ((produto.referenciaUnidade * produto.pecasPorCaixa) * produto.caixa).toFixed(2)

          produto.quantidadeExibicao = produto.quantidade.toString().replace('.', ',')

          if (produto.caixa < 0) {
            produto.caixa = 0
          }

          if (produto.pecas <= 0) {
            this.showDialog(3000, 'Tem certeza que deseja remover este produto?', produto)
          } else {
            this.atualizarListaCompra(produto)
          }
        } else if (this.exibirPecas) {
          produto.pecas -= 1

          produto.caixa = produto.caixa ? Math.ceil(produto.pecas / produto.pecasPorCaixa) : 0
          produto.quantidade = (produto.pecas * produto.referenciaUnidade).toFixed(2)

          produto.quantidadeExibicao = produto.quantidade.toString().replace('.', ',')

          if (produto.pecas < 0) {
            produto.pecas = 0
          }

          if (produto.pecas <= 0) {
            this.showDialog(3000, 'Tem certeza que deseja remover este produto?', produto)
          } else {
            this.atualizarListaCompra(produto)
          }
        } else if (this.exibirQuantidade) {
          produto.quantidade -= 1

          produto.quantidadeExibicao = produto.quantidade.toString().replace('.', ',')

          produto.pecas = Math.ceil(produto.quantidade / produto.referenciaUnidade)
          produto.caixa = produto.caixa ? Math.ceil((produto.quantidade / produto.referenciaUnidade) / produto.pecasPorCaixa) : 0

          if (produto.quantidade < 0) {
            produto.quantidade = 0
          }

          if (produto.quantidade <= 0) {
            this.showDialog(3000, 'Tem certeza que deseja remover este produto?', produto)
          } else {
            this.atualizarListaCompra(produto)
          }
        }
      },

      removeProduto (produto) {
        produto.quantidade = 0
        produto.caixa = 0
        produto.pecas = 0

        this.showDialog(3000, 'Tem certeza que deseja remover este produto?', produto)
      },

      confirmRemoveProduto (produto) {
        var indice = this.listaprodutos.indexOf(produto)

        this.listaprodutos.splice(indice, 1)

        this.cart = this.listaprodutos.length

        this.updateCart()

        this.showSnackbar(this.corPrimaria, 2000, 'Produto removido do carrinho com sucesso.')

        this.atualizarListaCompra(produto)
      },

      resetProduto (produto) {
        if (this.exibirCaixa) {
          produto.caixa = 1
          produto.pecas = produto.caixa * produto.pecasPorCaixa
          produto.quantidade = ((produto.referenciaUnidade * produto.pecasPorCaixa) * produto.caixa).toFixed(2)

          produto.quantidadeExibicao = produto.quantidade.toString().replace('.', ',')
        } else if (this.exibirPecas) {
          produto.pecas = 1
          produto.caixa = Math.ceil(produto.pecas / produto.pecasPorCaixa)
          produto.quantidade = (produto.pecas * produto.referenciaUnidade).toFixed(2)

          produto.quantidadeExibicao = produto.quantidade.toString().replace('.', ',')
        } else if (this.exibirQuantidade) {
          console.log(produto)
          produto.quantidade = 1
          produto.pecas = 1
          produto.caixa = 1

          produto.quantidadeExibicao = produto.quantidade.toString().replace('.', ',')
        }

        this.showSnackbar(this.corPrimaria, 2000, 'Produto não foi removido do carrinho.')

        this.atualizarListaCompra(produto)
      },

      /* Método que atuliza o ícone da quantidade itens no pedido */
      updateCart () {
        this.$root.$emit('update-cart', this.cart)
      },

      atualizaListaCompraKeyup (produto) {
        if (this.exibirCaixa) {
          produto.caixa = produto.caixa ? parseFloat(produto.caixa) : 1

          produto.pecas = produto.caixa * produto.pecasPorCaixa
          produto.quantidade = ((produto.referenciaUnidade * produto.pecasPorCaixa) * produto.caixa).toFixed(2)

          produto.quantidadeExibicao = produto.quantidade.toString().replace('.', ',')
          this.atualizarListaCompra(produto)
        } else if (this.exibirPecas) {
          produto.pecas = parseFloat(produto.pecas)

          produto.caixa = produto.caixa ? Math.ceil(produto.pecas / produto.pecasPorCaixa) : 0
          produto.quantidade = (produto.pecas * produto.referenciaUnidade).toFixed(2)

          produto.quantidadeExibicao = produto.quantidade.toString().replace('.', ',')
          this.atualizarListaCompra(produto)
        } else if (this.exibirQuantidade) {
          produto.quantidade = parseFloat(produto.quantidade)

          produto.quantidadeExibicao = produto.quantidade.toString().replace('.', ',')

          produto.pecas = Math.ceil(produto.quantidade / produto.referenciaUnidade)
          produto.caixa = produto.caixa ? Math.ceil((produto.quantidade / produto.referenciaUnidade) / produto.pecasPorCaixa) : 0

          this.atualizarListaCompra(produto)
        }
      },

      async atualizarListaCompra (produto) {
        await Carrinho.updateItenCart(produto, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status === true) {
            produto.caixa = resposta.data.caixa
            produto.pecas = resposta.data.pecas
            produto.quantidade = resposta.data.quantidade

            this.showSnackbar(this.corPrimaria, 2000, 'Produto atualizado com sucesso.')

            this.valorTotalCompra()
          } else if (resposta.data.message === 'Item removido com sucesso.') {
            this.valorTotalCompra()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.status === false) {
            this.carregaProdutos()
            this.showSnackbar('error', 10000, e.data.message)
          }
        })
      },

      valorTotalCompra () {
        const carrinho = this.listaprodutos.map((lista) => {
          var listacompra = ({
            valor: parseFloat(lista.preco.toString().replace(',', '.')) * parseFloat(lista.quantidade.toString().replace(',', '.')),
          })

          return listacompra
        })

        this.soma = carrinho.reduce((sum, valor) => {
          return sum + valor.valor
        }, 0)

        this.soma = this.soma.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      },

      finalizaCompra () {
        if (this.listaprodutos) {
          this.$router.push('/finaliza-compra')
        } else {
          alert('Não há itens no carrinho para poder finalizar a compra, volte na aba lista de produtos para continuar comprando!')
          this.$router.push('/lista-produtos')
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      showDialog (timeout, message, produto) {
        this.dialog.visible = true
        this.dialog.timeout = timeout
        this.dialog.message = message
        this.dialog.produto = produto
      },
    },
  }
</script>

<style lang="sass">
  #ul_cart
    list-style-type: none

  #li_cart
    border-style: none
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.3)
    width: 50%
    text-align: center
    float: left
    margin-right: 10px
    border-color: green

  #input_cart
    width: 10%

  #divFinaliza
    margin-left: 1em

  #btnFinaliza_cart
    margin-left: 3em
    border-radius: 1.8rem

  #iconCart
    margin-bottom: 5px

  #lista-produtos-form
    margin-top: 4em

  #btnAdd_cart
    border-radius: 1.8rem

  #alertaProduto
    color: red

  #iconDelete_cart
    margin-top: -1rem

  #btnBloqueado
    text-decoration: underline overline dotted red

  input[type=number]::-webkit-inner-spin-button
    -webkit-appearance: none

  input[type=number]
    -moz-appearance: textfield
    appearance: textfield

  #linhaHorizontal_cart
    width: 100%
    border: 1px solid gray
    margin-top: 1rem
    margin-bottom: 1rem

  #imagemProduto_cart
    margin: auto
    // display: grid
    // width: 256px
    // height: 256px

  #imagem_carts
    margin: auto
    display: grid
    width: 256px
    height: 256px

</style>
